import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ProtectedRoute from './ProtectedRoute';
import { PageSuspense } from './pages';

function ProtectedPage({
  component,
  lazy = true,
  hasPermission = true,
  ...otherProps
}) {
  return lazy ? (
    <ProtectedRoute hasPermission={hasPermission} {...otherProps}>
      <PageSuspense>{component}</PageSuspense>
    </ProtectedRoute>
  ) : (
    <ProtectedRoute hasPermission={hasPermission} {...otherProps}>
      {component}
    </ProtectedRoute>
  );
}

ProtectedPage.propTypes = {
  component: PropTypes.element,
  lazy: PropTypes.bool,
  hasPermission: PropTypes.bool,
};

export default memo(ProtectedPage);
